import classNames from 'classnames'

import styles from './Progress.module.scss'

export const Progress = ({ percent, className }) => {
  const complete = percent >= 100
  return (
    <div className={classNames(styles.progressRoot, className)}>
      <div className={styles.progress}>
        <div
          className={classNames(
            styles.progressBar,
            !complete && styles.progressBarAnimated,
            complete && styles.progressBarComplete
          )}
          style={{
            width: `${percent}%`,
          }}
          role="progressbar"
        />
      </div>
      <div className={styles.progressText}>{percent}%</div>
    </div>
  )
}
